import type { SessionViewerResult } from '../auth/api';
import { DashboardShell as OrganizationDashboardShell } from './OrganizationDashboardShell';
import { ScrollToTopButton } from './ScrollToTopButton';
import { SupervisorShell } from './SupervisorShell';
import { NavigationPreferences } from './navigation-preferences';

interface DashboardShellProps {
  readonly viewer: SessionViewerResult;
  readonly csrfToken: string;
  readonly onReauthenticate: () => void;
  readonly onLogout: () => void;
  readonly logoutPending?: boolean;
  readonly notificationCount?: number;
}

/**
 * Point d'entrée du shell connecté.
 *
 * S1-08 isole désormais le plan de contrôle du Superviseur du shell des organisations. Cette
 * séparation évite d'introduire progressivement des données métier d'organisation dans l'espace
 * plateforme tout en conservant le shell S1-06 inchangé pour les membres d'organisation.
 */
export function DashboardShell(props: DashboardShellProps): React.JSX.Element {
  const shell =
    props.viewer.accountKind === 'PLATFORM_SUPERVISOR' ? (
      <SupervisorShell {...props} />
    ) : (
      <OrganizationDashboardShell {...props} />
    );

  return (
    <NavigationPreferences viewer={props.viewer}>
      {shell}
      <ScrollToTopButton />
    </NavigationPreferences>
  );
}
